import Form from "rc-field-form";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button";
import Field from "../../../../components/Field";
import NumberInput from "../../../../components/Inputs/NumberInput";
import ResourceSelect from "../../../../components/Inputs/ResourceSelect";
import Select from "../../../../components/Inputs/Select";
import Text from "../../../../components/Inputs/Text";
import { generateErrorsConfigForForm } from "../../../../utils/helpers/errors";
import {
	getSettingsResourceSearchFilters,
	renderSettingsResourceLabel,
} from "../../../../utils/helpers/settings";

function EditForm({ close, values, error, loading, update }) {
	const { t } = useTranslation();
	const [form] = Form.useForm();

	const onFinish = useCallback((data) => {
		update(
			values.id,
			{
				id: values.id,
				...data,
				plan: data.plan.id,
				amount: Number(data.amount) || 0,
			},
			close,
		);
	}, [update, values, close]);

	useEffect(() => {
		form.resetFields();
		form.setFieldsValue({
			plan: values?.plan,
			amount: 0,
			addOrRemove: "add",
			comment: "",
		});
	}, [form, values]);

	useEffect(() => {
		const fieldErrors = generateErrorsConfigForForm(["data"], error);
		form.setFields(fieldErrors);
	}, [form, error]);

	return (
		<Form
			form={form}
			layout="vertical"
			onFinish={onFinish}
			scrollToFirstError
		>
			<Field
				name="plan"
				label={t("plan")}
				rules={[
					{
						required: true,
						message: t("required-plan"),
					},
				]}
			>
				<ResourceSelect
					labelPropName="description"
					resourcePath="/timeoff?status=active"
					renderLabel={renderSettingsResourceLabel}
					placeholder={t("plan")}
					hasSearch
					getSearchFilters={getSettingsResourceSearchFilters}
					disabled
				/>
			</Field>

			<Field
				name="addOrRemove"
				label={t("choose-your-action")}
				rules={[
					{
						required: true,
						message: t("this-field-is-required"),
					},
				]}
			>
				<Select
					placeholder={t("choose-your-action")}
					options={[
						{ label: t("add-amount"), value: "add" },
						{ label: t("remove-amount"), value: "remove" },
					]}
				/>
			</Field>

			<Field
				name="amount"
				label={t("amount")}
				rules={[
					{
						required: true,
						message: t("amount-is-required"),
					},
				]}
			>
				<NumberInput placeholder={t("amount")} />
			</Field>

			<Field name="comment" label={t("comment")}>
				<Text placeholder={t("comment")} />
			</Field>

			<div className="d-flex justify-content-end">
				<Button
					className="btn-round btn-icon shadow-none border btn btn-secondary btn-sm"
					onClick={close}
					disabled={loading}
				>
					{t("cancel")}
				</Button>

				<Button
					color="primary"
					type="submit"
					loading={loading}
					className="btn-round btn-icon shadow-none border px-3 btn btn-dark btn-sm"
				>
					{t("save")}
				</Button>
			</div>
		</Form>
	);
}

export default EditForm;
